import { BLOG_FACTS } from "../facts";
import { formatPost } from "../format-post";

const w = BLOG_FACTS.stateFormats.B2.forms.reklama.words;
const range = `${w.min}–${w.max}`;

export const POST = formatPost({
  form: "reklama",
  listed: { B1: false, B2: true },
  phrases: [
    ["Masz dość…? / Szukasz…?", "Marzysz o…? / Chcesz…?"],
    ["Zapraszamy do… / Oferujemy…", "Tylko u nas… / Jako jedyni w mieście…"],
    ["profesjonalna obsługa, doświadczeni instruktorzy", "atrakcyjne ceny, pierwsza lekcja gratis"],
    ["Zapisz się już dziś! / Nie czekaj!", "Liczba miejsc ograniczona."],
    ["Szczegóły na stronie…", "Zadzwoń: 600 100 200"],
  ],
  sample: `Masz dość ekranu? Zrób coś własnymi rękami!

Pracownia Ceramiki „Glina” zaprasza dorosłych na wieczorne warsztaty. W cztery tygodnie nauczysz się robić kubki, talerze i miski na kole garncarskim. Pracujemy w małych grupach, a wszystkie materiały są w cenie. Pierwsze zajęcia — gratis!

Zapisz się już dziś: tel. 600 100 200, www.glina-warsztaty.pl`,
  text: {
    pl: {
      title: "Jak napisać reklamę po polsku: wzór krótkiego tekstu na egzamin B2",
      description: `Reklama na egzaminie B2: hasło, co oferujesz, korzyść dla klienta, szczegóły, wezwanie do działania i kontakt. Zwroty i wzór na ${range} słów.`,
      lead: "Reklama ma przyciągnąć uwagę i skłonić do działania. Zaczynasz od hasła albo pytania do klienta („Masz dość…?”), mówisz, co oferujesz i co klient na tym zyska, podajesz szczegóły — cenę, miejsce, termin — i kończysz wezwaniem („Zapisz się już dziś!”) z kontaktem. Tryb rozkazujący i krótkie zdania są tu na miejscu.",
      summary: [
        "Pięć części: hasło, oferta, korzyść, szczegóły, wezwanie do działania z kontaktem.",
        "Tryb rozkazujący i pytania do klienta: „Zapisz się!”, „Szukasz…?”.",
      ],
      intro: [
        { kind: "p", text: "Rozporządzenie wymienia reklamę tylko na liście form B2. Arkusze proszą o reklamę usługi na portalu internetowym: hotelu dla zwierząt, animatora zabaw dla dzieci, kursu tańca." },
      ],
      structureTitle: "Jak napisać reklamę krok po kroku?",
      structure: [
        "Hasło albo pytanie do klienta: „Masz dość…?”, „Marzysz o…?”.",
        "Oferta: kto i co oferuje — nazwa firmy, usługa.",
        "Korzyść: co klient zyska — „nauczysz się…”, „odpoczniesz…”.",
        "Szczegóły: cena, miejsce, termin, coś za darmo.",
        "Wezwanie i kontakt: „Zapisz się już dziś!”, telefon, strona.",
      ],
      phrasesTitle: "Zwroty do reklamy",
      phrasesHead: ["Hasło i oferta", "Szczegóły i wezwanie"],
      sampleTitle: "Wzór reklamy ({words})",
      sampleNote: "Pytanie na początku, korzyść dla klienta, szczegóły i wezwanie z kontaktem. Firma i tekst są zmyślone, nie z arkusza. Formy „zapisz się”, „zróbcie” opisuje wpis [tryb rozkazujący](/poradnik/tryb-rozkazujacy).",
      faq: [
        { q: "Czym różni się reklama od ogłoszenia?", a: "Ogłoszenie informuje (sprzedam, szukam, zaginął). Reklama przekonuje: pokazuje korzyść i wzywa do działania. Ogłoszenie opisuje wpis [ogłoszenie](/poradnik/ogloszenie)." },
        { q: "Na „ty” czy na „Państwo”?", a: "Oba są możliwe. Ważne, żeby trzymać się jednej formy w całym tekście." },
        { q: "Czy reklama jest na egzaminie B1?", a: "Nie ma jej na liście form B1 w rozporządzeniu ani w żadnym arkuszu B1 w bibliotece." },
      ],
      cta: { title: "Napisz reklamę na czas", text: "Część pisemna z prawdziwych arkuszy B2, a tekst ocenia model językowy. Jeden arkusz B2 jest bezpłatny." },
    },
    uk: {
      title: "Як написати рекламу польською: зразок короткого тексту для іспиту B2",
      description: `Реклама на іспиті B2: гасло, що пропонуєш, вигода для клієнта, деталі, заклик до дії й контакт. Звороти і зразок на ${range} слів.`,
      lead: "Реклама (reklama) має привернути увагу й спонукати до дії. Починаєш із гасла чи питання до клієнта («Masz dość…?»), кажеш, що пропонуєш і що клієнт із цього матиме, даєш деталі — ціну, місце, час — і закінчуєш закликом («Zapisz się już dziś!») з контактом. Наказовий спосіб і короткі речення тут доречні.",
      summary: [
        "П'ять частин: гасло, пропозиція, вигода, деталі, заклик до дії з контактом.",
        "Наказовий спосіб і питання до клієнта: «Zapisz się!», «Szukasz…?».",
      ],
      intro: [
        { kind: "p", text: "Розпорядження називає рекламу лише в переліку форм B2. Набори просять рекламу послуги на інтернет-порталі: готелю для тварин, аніматора дитячих свят, курсу танців." },
      ],
      structureTitle: "Як написати рекламу крок за кроком?",
      structure: [
        "Гасло або питання до клієнта: «Masz dość…?», «Marzysz o…?».",
        "Пропозиція: хто й що пропонує — назва фірми, послуга.",
        "Вигода: що клієнт отримає — «nauczysz się…», «odpoczniesz…».",
        "Деталі: ціна, місце, час, щось безкоштовно.",
        "Заклик і контакт: «Zapisz się już dziś!», телефон, сайт.",
      ],
      phrasesTitle: "Звороти для реклами",
      phrasesHead: ["Гасло і пропозиція", "Деталі і заклик"],
      sampleTitle: "Зразок реклами ({words})",
      sampleNote: "Питання на початку, вигода для клієнта, деталі й заклик із контактом. Фірма й текст вигадані, не з набору. Форми «zapisz się», «zróbcie» описує стаття [наказовий спосіб](/poradnik/tryb-rozkazujacy).",
      faq: [
        { q: "Чим реклама відрізняється від оголошення?", a: "Оголошення інформує (sprzedam, szukam, zaginął). Реклама переконує: показує вигоду й закликає діяти. Оголошення описує стаття [оголошення](/poradnik/ogloszenie)." },
        { q: "На «ty» чи на «Państwo»?", a: "Можливі обидва. Важливо триматися однієї форми в усьому тексті." },
        { q: "Чи є реклама на іспиті B1?", a: "Її немає ні в переліку форм B1 у розпорядженні, ні в жодному наборі B1 у бібліотеці." },
      ],
      cta: { title: "Напиши рекламу на час", text: "Письмова частина зі справжніх наборів B2, а текст оцінює мовна модель. Один набір B2 безкоштовний." },
    },
    ru: {
      title: "Как написать рекламу на польском: образец короткого текста для экзамена B2",
      description: `Реклама на экзамене B2: слоган, что предлагаешь, выгода для клиента, детали, призыв к действию и контакт. Обороты и образец на ${range} слов.`,
      lead: "Реклама (reklama) должна привлечь внимание и побудить к действию. Начинаешь со слогана или вопроса к клиенту («Masz dość…?»), говоришь, что предлагаешь и что клиент от этого получит, даёшь детали — цену, место, время — и заканчиваешь призывом («Zapisz się już dziś!») с контактом. Повелительное наклонение и короткие предложения здесь уместны.",
      summary: [
        "Пять частей: слоган, предложение, выгода, детали, призыв к действию с контактом.",
        "Повелительное наклонение и вопросы к клиенту: «Zapisz się!», «Szukasz…?».",
      ],
      intro: [
        { kind: "p", text: "Распоряжение называет рекламу только в перечне форм B2. Наборы просят рекламу услуги на интернет-портале: гостиницы для животных, аниматора детских праздников, курса танцев." },
      ],
      structureTitle: "Как написать рекламу по шагам?",
      structure: [
        "Слоган или вопрос к клиенту: «Masz dość…?», «Marzysz o…?».",
        "Предложение: кто и что предлагает — название фирмы, услуга.",
        "Выгода: что получит клиент — «nauczysz się…», «odpoczniesz…».",
        "Детали: цена, место, время, что-то бесплатно.",
        "Призыв и контакт: «Zapisz się już dziś!», телефон, сайт.",
      ],
      phrasesTitle: "Обороты для рекламы",
      phrasesHead: ["Слоган и предложение", "Детали и призыв"],
      sampleTitle: "Образец рекламы ({words})",
      sampleNote: "Вопрос в начале, выгода для клиента, детали и призыв с контактом. Фирма и текст вымышлены, не из набора. Формы «zapisz się», «zróbcie» описывает статья [повелительное наклонение](/poradnik/tryb-rozkazujacy).",
      faq: [
        { q: "Чем реклама отличается от объявления?", a: "Объявление информирует (sprzedam, szukam, zaginął). Реклама убеждает: показывает выгоду и призывает действовать. Объявление описывает статья [объявление](/poradnik/ogloszenie)." },
        { q: "На «ty» или на «Państwo»?", a: "Возможны оба. Важно держаться одной формы во всём тексте." },
        { q: "Есть ли реклама на экзамене B1?", a: "Её нет ни в перечне форм B1 в распоряжении, ни в одном наборе B1 в библиотеке." },
      ],
      cta: { title: "Напиши рекламу на время", text: "Письменная часть из настоящих наборов B2, а текст оценивает языковая модель. Один набор B2 бесплатный." },
    },
    en: {
      title: "How to write an advert in Polish: a short-text model for the B2 exam",
      description: `An advert in the B2 exam: a slogan, what you offer, what the customer gains, details, a call to action and contact. Phrases and a ${range}-word model.`,
      lead: "An advert (reklama) has to catch the eye and get people to act. You open with a slogan or a question to the customer (\"Masz dość…?\"), say what you offer and what the customer gains, give the details — price, place, time — and end with a call (\"Zapisz się już dziś!\") and contact details. The imperative and short sentences belong here.",
      summary: [
        "Five parts: slogan, offer, benefit, details, a call to action with contact.",
        "The imperative and questions to the customer: \"Zapisz się!\", \"Szukasz…?\".",
      ],
      intro: [
        { kind: "p", text: "The regulation lists the advert only among the B2 forms. The papers ask for an advert for a service on a website: a pet hotel, a children's party entertainer, a dance course." },
      ],
      structureTitle: "How do you write an advert, step by step?",
      structure: [
        "Slogan or a question to the customer: \"Masz dość…?\", \"Marzysz o…?\".",
        "Offer: who offers what — the business's name, the service.",
        "Benefit: what the customer gets — \"nauczysz się…\", \"odpoczniesz…\".",
        "Details: price, place, time, something free.",
        "Call and contact: \"Zapisz się już dziś!\", a phone number, a website.",
      ],
      phrasesTitle: "Phrases for an advert",
      phrasesHead: ["Slogan and offer", "Details and call to action"],
      sampleTitle: "A model advert ({words})",
      sampleNote: "A question up front, a benefit for the customer, details, and a call with contact details. The business and the text are made up, not from a paper. Forms like \"zapisz się\", \"zróbcie\" are in [the imperative](/poradnik/tryb-rozkazujacy).",
      faq: [
        { q: "How is an advert different from an ogłoszenie?", a: "An ogłoszenie informs (sprzedam, szukam, zaginął). An advert persuades: it shows a benefit and calls for action. The ogłoszenie has [a post of its own](/poradnik/ogloszenie)." },
        { q: "\"Ty\" or \"Państwo\"?", a: "Either works. Keep to one throughout the text." },
        { q: "Is the advert in the B1 exam?", a: "It is neither on the regulation's B1 list of forms nor on any B1 paper in the library." },
      ],
      cta: { title: "Write an advert against the clock", text: "The writing part from real B2 papers, with your text marked by a language model. One B2 paper is free." },
    },
  },
});
